import "./ReservationSchedulerNew.css";
import { STATUS_COLOURS, STATUS_LIST } from "../../../constants/ReservationStatus";

function StatusLegend() {
  return (
    <div className="rs-status-legend">
      <div className="rs-status-legend__title">Status</div>

      <div className="rs-status-legend__items">
        {STATUS_LIST.map((status) => {
          const colours = STATUS_COLOURS[status];
          return (
            <div key={status} className="rs-status-legend__item">
              <span
                className="rs-status-legend__dot"
                style={{ backgroundColor: colours.bg }}
                aria-hidden
              />
              <span className="rs-status-legend__label">{status}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default StatusLegend;
